import React from "react";
import { ConfigProvider, Modal, Button, Form, message } from "antd";

interface ModalComponentProps {
  open: boolean;
  title: string;
  content: React.ReactNode;
  okText: string;
  onClose: () => void;
  onAddSuccess: (values: unknown) => void;
}

const FormModalComponent: React.FC<ModalComponentProps> = ({
  open,
  title,
  content,
  okText,
  onClose,
  onAddSuccess,
}) => {
  const [form] = Form.useForm();

  const handleAdd = () => {
    form
      .validateFields()
      .then(async (values) => {
        try {
          await onAddSuccess(values);
          form.resetFields();
          onClose();
        } catch {
          message.error("Failed to add prospect");
        }
      })
      .catch((errorInfo) => {
        console.error("Validation Failed:", errorInfo);
      });
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            controlHeight: 40,
            fontSize: 16,
            borderRadius: 24,
            defaultColor: "rgba(0,0,0,1)",
            fontWeight: 600,
          },
          Modal: {
            titleFontSize: 24,
          },
        },
      }}
    >
      <Modal
        title={title}
        open={open}
        onCancel={onClose}
        footer={[
          <Button key="cancel" onClick={onClose}>
            Cancel
          </Button>,
          <Button key="ok" type="primary" onClick={handleAdd}>
            {okText}
          </Button>,
        ]}
      >
        {React.cloneElement(
          content as React.ReactElement<{ form: typeof form }>,
          { form },
        )}
      </Modal>
    </ConfigProvider>
  );
};

export default FormModalComponent;
